var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_setup.panelClicked}},[(_vm.$slots.default)?[_vm._t("default")]:[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }